export default "__VITE_ASSET___oIwyR8U__"